<script lang="ts">
    import { List, ListItem, Checkbox } from 'framework7-svelte';
    import { createEventDispatcher } from 'svelte';
    import { _ } from 'svelte-i18n';
    
    import FloatingButton from '../FloatingButton.svelte';

    export let resetDays: boolean = false;

    const defaultDays = [
        $_('shared.MONDAY_SHORT'), 
        $_('shared.TUESDAY_SHORT'), 
        $_('shared.WEDNESDAY_SHORT'), 
        $_('shared.THURSDAY_SHORT'), 
        $_('shared.FRIDAY_SHORT'), 
        $_('shared.SATURDAY_SHORT'), 
        $_('shared.SUNDAY_SHORT')
    ];
    const dispatch = createEventDispatcher();
    
    let selectedDays: string[] = defaultDays;
    
    const days = [
        { label: $_('shared.MONDAY'), value: $_('shared.MONDAY_SHORT') },
        { label: $_('shared.TUESDAY'), value: $_('shared.TUESDAY_SHORT') },
        { label: $_('shared.WEDNESDAY'), value: $_('shared.WEDNESDAY_SHORT') },
        { label: $_('shared.THURSDAY'), value: $_('shared.THURSDAY_SHORT') },
        { label: $_('shared.FRIDAY'), value: $_('shared.FRIDAY_SHORT') },
        { label: $_('shared.SATURDAY'), value: $_('shared.SATURDAY_SHORT') },
        { label: $_('shared.SUNDAY'), value: $_('shared.SUNDAY_SHORT') }
    ];

    $: daysWithChecked = days.map((day) => ({
        ...day,
        checked: selectedDays.includes(day.value)
    }));

    $: activeDays = selectedDays;
    $: dispatch('change', activeDays);
    $: if(resetDays){
        selectedDays = defaultDays
        resetDays = false
    }

    function toggleDay(day) {
        let updated;

        if (selectedDays.includes(day.value)) {
            updated = selectedDays.filter((v) => v !== day.value);
        } else {
            updated = [...selectedDays, day.value];
        }

        selectedDays = updated.sort((a, b) => days.findIndex((d) => d.value === a) - days.findIndex((d) => d.value === b));
    }
</script>

<FloatingButton label={activeDays.length > 0 ? activeDays.join(', ') : $_('pages.dashboard.SELECT_DAYS')} active={activeDays.length > 0} activeIcon="check" inactiveIcon="">
    <List inset strong>
        {#each daysWithChecked as day}
            <ListItem title={day.label} on:click={() => toggleDay(day)}>
                <Checkbox
                    slot="after"
                    bind:checked={day.checked}
                    on:change={(e) => {
                        e.stopPropagation();
                    }}
                />
            </ListItem>
        {/each}
    </List>
</FloatingButton>
